export const SentidoBobinadoConfiguracion = Object.freeze({
  SISTEMA: 'sistema',
  PERSONALIZADA: 'personalizada',
});

export const SentidoBobinadoConfiguracionOptions = [
  { Codigo: SentidoBobinadoConfiguracion.SISTEMA, Descripcion: 'De sistema' },
  { Codigo: SentidoBobinadoConfiguracion.PERSONALIZADA, Descripcion: 'Personalizada' },
];
